import React from 'react';
import classNames from 'classnames';
const Container = ({ children, className, size }) => {
    if (!size) {
        size = 'normal';
    }
    const classNameResult = classNames('ac-container', 'ac-container' + (size !== 'big' ? '-' + size : ''), className);
    return React.createElement("div", { className: classNameResult }, children);
};
export { Container };
//# sourceMappingURL=Container.js.map